
import { Tooltip, useTheme } from '@mui/material';

import { useTranslate } from 'src/locales';
import { RepresentationStatus } from 'src/services/applications/applications.types';

import Iconify from 'src/components/iconify';

export function ApplicationRepresentationStatusIcon({ status, size = 16 }: { status: RepresentationStatus, size?: number }) {

  const { t } = useTranslate();

  const theme = useTheme();

  if (!status) return null;

  return (
    <Tooltip title={t(`applications.representation_tooltip.${status}`)} sx={{ cursor: 'help' }}>
      <Iconify
        icon={status === RepresentationStatus.ACTIVE ? "solar:user-check-bold-duotone" : "solar:user-block-bold-duotone"}
        color={status === RepresentationStatus.ACTIVE ? theme.palette.primary.dark : theme.palette.warning.dark}
        width={size}
        height={size} />
    </Tooltip>
  )
}
